class Pop {
    constructor() {
        this.containers = []
    }
    getPointDom(props) {
        return `<img src=${props.url} style="width:20px;height:20px">`
    }
    addPop(p, properties = {}) {
        const pop = new map3d.Function.PopUp({
            id: properties.id,
            container: "ThreeContainer",
            toTop: properties.toTop ? properties.toTop : 0,
            showByDistance: false,
            zIndex: properties.zIndex ? properties.zIndex : 0
        });
        pop.setPreventEventNone(true)
        pop.setShowDistance(properties.distance ? properties.distance : Infinity)
        pop.setShowByDistance(false)
        pop.bindC3([p[0], p[1], p[2]]);
        const url = properties.url
        const html = this.getPointDom({
            url: url
        })
        pop.html(html)
        this.containers.push(pop)
    }
    remove(id) {
        for (let i = this.containers.length - 1; i >= 0; i--) {
            if (this.containers[i].id.indexOf(id) >= 0) {
                this.containers[i].destroy()
                this.containers.splice(i, 1);
            }
        }
    }
    find(id) {
        const results = []
        this.containers.forEach((item) => {
            if (item.id.indexOf(id) >= 0) {
                results.push(item)
            }
        })
        return results
    }
}
export default new Pop()


// WEBPACK FOOTER //
// ./src/mapfunction/Pop.js